import { render, staticRenderFns } from "./StudyProgramStatusIcon.vue?vue&type=template&id=2b5e7986&scoped=true"
import script from "./StudyProgramStatusIcon.vue?vue&type=script&lang=ts"
export * from "./StudyProgramStatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./StudyProgramStatusIcon.vue?vue&type=style&index=0&id=2b5e7986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e7986",
  null
  
)

export default component.exports